// extracted by mini-css-extract-plugin
module.exports = {"alert":"FeeSelector_alert__1Wvq2","title":"FeeSelector_title__8YH1k","gasTankEnabled":"FeeSelector_gasTankEnabled__bc5v-","gasTankDisabled":"FeeSelector_gasTankDisabled__3RDvE"};